import React, { useState } from 'react';
import { IconTrash } from './Icons';

// Botão de exclusão de documento (CR-4). Renderiza nada se !canDelete
// (admin ou compartilhador). `file` deve ser o caminho completo do blob (fullPath).
function DeleteDocButton({ canDelete, container, file, location, onDeleted }) {
  const [busy, setBusy] = useState(false);
  if (!canDelete) return null;

  const handleDelete = async (e) => {
    e.stopPropagation();
    const base = (file || '').split('/').pop();
    if (!window.confirm(`Excluir "${base}"?\n\nO arquivo vai para a lixeira. Apenas administradores podem restaurá-lo ou excluí-lo definitivamente.`)) return;

    setBusy(true);
    try {
      const params = new URLSearchParams({ container, file });
      if (location) params.append('location', location);
      const res = await fetch(`/api/deleteDocument?${params}`, { method: 'DELETE' });
      const data = await res.json();
      if (data.success) {
        if (onDeleted) onDeleted(file);
      } else {
        alert(data.error || 'Falha ao excluir documento');
      }
    } catch (err) {
      alert(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      onClick={handleDelete}
      disabled={busy}
      title="Excluir documento"
      aria-label="Excluir documento"
      style={{
        display: 'inline-grid',
        placeItems: 'center',
        background: '#fde2e1',
        color: '#a12622',
        border: '1px solid #f3b6b3',
        borderRadius: 6,
        padding: '6px 10px',
        cursor: busy ? 'default' : 'pointer',
        fontSize: 14,
        marginLeft: 8,
        flexShrink: 0
      }}
    >
      {busy ? '...' : <IconTrash size={16} />}
    </button>
  );
}

export default DeleteDocButton;
